export const homeObjOne = {
    id:'about',
    lightBg:false,
    lightText:true,
    lightTextDesc:true,
    topLine:'#goodgreenera',
    headline:'Act, Inspire, Motivate',
    description:'Share your contributions towards environment, with the world',
     buttonLabel:'Get Started',
    imgStart:false,
    img:require('../../images/mind.jpg').default,
    alt:'pic',
    dark:true,
    primary:true,
    darkText:false
}
export const homeObjTwo = {
    id:'discover',
    lightBg:true,
    lightText:false,
    lightTextDesc:false,
    topLine:'#GoodGreenEra',
    headline:'The World is shrinking, so is nature!',
    description:'Get access to all your college notes in a tap!',

    imgStart:true,
    img:require('../../images/1.jpg').default,
    alt:'pic',
    dark:false,
    primary:false,
    darkText:true
}

